import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import { useMemo, useState, type ReactNode } from "react";

import { makeQueryClient } from "./queryClient";
import { SidePanelContext } from "./sidePanel";

type ProvidersProps = {
  children: ReactNode;
  client?: QueryClient;
  /** The side panel open from the start: for the tests of what the panels show (the app starts closed). */
  sidePanelOpen?: boolean;
};

export function Providers({ children, client, sidePanelOpen = false }: ProvidersProps) {
  const [queryClient] = useState(() => client ?? makeQueryClient());
  const [open, setOpen] = useState(sidePanelOpen);
  const sidePanel = useMemo(() => ({ open, setOpen }), [open]);
  return (
    <QueryClientProvider client={queryClient}>
      <SidePanelContext.Provider value={sidePanel}>{children}</SidePanelContext.Provider>
    </QueryClientProvider>
  );
}
